<template>
    <section class="w-full mb-16 max-w-465 md:mb-30">
        <div class="relative w-full bg-blue">

            <panel-transition>
                <admin-create v-if="isAdminActive" @created="onCreated" @cancel="toggleAdmin" class="panel active"></admin-create>
                <div v-else class="flex items-center justify-center h-465">
                    <div @click="toggleAdmin" class="cursor-pointer">
                        <svg xmlns="http://www.w3.org/2000/svg" width="92.001" height="92" viewBox="0 0 92.001 92"><path id="Subtraction_43" data-name="Subtraction 43" d="M5315-1265a45.716,45.716,0,0,1-17.906-3.615,45.846,45.846,0,0,1-14.622-9.858,45.855,45.855,0,0,1-9.858-14.622A45.719,45.719,0,0,1,5269-1311a45.715,45.715,0,0,1,3.615-17.9,45.854,45.854,0,0,1,9.858-14.621,45.852,45.852,0,0,1,14.622-9.858A45.716,45.716,0,0,1,5315-1357a45.716,45.716,0,0,1,17.906,3.615,45.852,45.852,0,0,1,14.622,9.858,45.854,45.854,0,0,1,9.858,14.621A45.715,45.715,0,0,1,5361-1311a45.719,45.719,0,0,1-3.615,17.906,45.855,45.855,0,0,1-9.858,14.622,45.846,45.846,0,0,1-14.622,9.858A45.716,45.716,0,0,1,5315-1265Zm-2-44v10h4v-10h10v-4h-10v-10h-4v10h-10v4Z" transform="translate(-5269 1357)" class="fill-blue-light hover:fill-blue-lightest"/></svg>
                    </div>
                </div>
            </panel-transition>

        </div>
    </section>
</template>

<script>
    import AdminCreate from "./panel/adminCreate";
    import PanelTransition from "../../components/transitions/panelTransition"

    export default {
        components: {
            AdminCreate,
            PanelTransition,
        },

        data() {
            return {
                isAdminActive: false,
            }
        },

        methods: {
            onCreated() {
                this.toggleAdmin()
            },

            toggleAdmin() {
                this.isAdminActive = !this.isAdminActive
            }
        }
    }
</script>
